import { render } from "./actorsPage.vue?vue&type=template&id=6cdebd48&scoped=true"
import script from "./actorsPage.vue?vue&type=script&lang=js"
export * from "./actorsPage.vue?vue&type=script&lang=js"

import "./actorsPage.vue?vue&type=style&index=0&id=6cdebd48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cdebd48"]])

export default __exports__